import React from 'react';
import { StorageSVG } from '../../@common_components/svgs/storage.svg';

const StorageIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <StorageSVG {...props} />;
};

export { StorageIcon };
